import React, { useState, useEffect } from "react";
import { Internal_Token } from "../services/auth";
import { decrypt } from "../utils/encodingdecoding";

function RefreshInternalToken() {
	// eslint-disable-next-line
	const [token, setToken] = useState(null);

	const fetchToken = async () => {
		// clientid/clientsecret are stored encrypted, and Internal_Token expects
		// plaintext credentials, so decrypt them here before passing through.
		let body = {
			clientid: decrypt(localStorage.getItem("clientid")),
			grant_type: "client_credentials",
			clientsecret: decrypt(localStorage.getItem("clientsecret")),
		};
		const response = await Internal_Token(body);

		localStorage.setItem("token_gen", JSON.stringify(response));
		setToken(response);
	};

	useEffect(() => {
		const intervalId = setInterval(() => {
			fetchToken();
		}, 58 * 60 * 1000);

		return () => clearInterval(intervalId);
	}, []);

	return <></>;
}
export default RefreshInternalToken;
